import { Component, Input, OnInit, inject } from '@angular/core';
import { DisplayComponent } from '@app/shared/components/display/display.component';
import { RewardBoxComponent } from '@app/shared/components/reward-box/reward-box.component';
import { AvatarComponent } from '@app/shared/components/avatar/avatar.component';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { User } from '@app/shared/models/user.model';
import { SharedModule } from '@app/shared/shared.module';
import { TournamentRanking } from '../../tournaments.model';
import { UserRepository } from '@app/shared/state/user/user.repository';
import { Reward } from '@app/shared/models/wallet.model';

@Component({
  selector: 'slotcom-tournament-ranking-list',
  templateUrl: './tournament-ranking-list.component.html',
  styleUrls: ['./tournament-ranking-list.component.scss'],
  standalone: true,
  imports: [DisplayComponent, AvatarComponent, RewardBoxComponent, SharedModule],
})
export class TournamentRankingListComponent implements OnInit {
  @Input() event: LimitedTimeEvent;
  @Input() player: TournamentRanking;
  @Input() rankingPosition: number;
  @Input() rankingPrize: Reward;

  readonly PODIUM = 3;

  isSelf: boolean;

  get user(): User {
    return this.userRepo.getUser();
  }

  private readonly userRepo = inject(UserRepository);

  ngOnInit() {
    this.isSelf = this.user.id === this.player.userId;
  }
}
